export const stopIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill="currentColor" d="M8 15.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15M5.187 6.125a.937.937 0 0 1 .938-.938h3.75a.937.937 0 0 1 .938.938v3.75a.94.94 0 0 1-.938.938h-3.75a.94.94 0 0 1-.938-.938z"/></svg>`,
    name: 'stop' as const
};